export default __webpack_public_path__ + "static/media/double-caret-active.c4b27c06.svg";